module.exports = __webpack_public_path__ + "static/media/HERO.24194e8a.png";